var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-header" },
    [
      _c(
        "router-link",
        { staticClass: "user-header__link", attrs: { to: { name: "help" } } },
        [_vm._v("Ajuda!")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: { name: "settings-user-information" } } },
        [
          _c("sc-gravatar", {
            staticClass: "user-header__image",
            attrs: { email: _vm.user.email, alt: _vm.user.name, size: 30 }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "user-header__link",
          attrs: { to: { name: "settings-user-information" } }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.user.email))]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              " - ID: " +
                _vm._s(
                  _vm.user.is_production
                    ? _vm.user.client_id
                    : _vm.user.sandbox_id
                )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "user-header__link user-header__logout",
          attrs: { href: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.logout($event)
            }
          }
        },
        [_vm._v("Sair")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59489678", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59489678","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/sc-user/ScUser.vue
// module id = null
// module chunks = 